<template>
    <div style="padding-left: 75px; padding-right: 75px; padding-top: 25px;">
        <div class="row hiddenprint"  v-if="inspection.company_name && !edited && this.$route">
            <div class="col s3">
                <a style="margin: 15px;" class="waves-effect waves-light btn-large emptygreen" :href="'#/customers/'+this.$route.params.customer_id+'/places/'+this.$route.params.place_id+'/inspections/'+this.$route.params.inspection_id +''">{{$t('menu.buttons.show_card')}} <i data-v-2a5bcde8="" class="material-icons right" style="line-height: inherit;">featured_play_list</i></a>
            </div>
            <div class="col offset-s6 s3 offset-l5 l4" style="display: inline-flex;">
                <a v-if="inspection.prebuilt_pdf_summary" style="margin: 15px;" class="btn btn-small green" :href="inspection.prebuilt_pdf_summary"><i class="material-icons right">print</i>{{$t('menu.buttons.print')}}</a>
                <a v-else-if="inspection.v3" style="margin: 15px;" class="btn btn-small green" :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '/summaryv2.pdf'">
                    <i class="material-icons right">print</i>{{$t('menu.buttons.print')}}
                </a>
                <a v-else style="margin: 15px;" class="btn btn-small green" :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '/summary.pdf'">
                    <i class="material-icons right">print</i>{{$t('menu.buttons.print')}}
                </a>
                <a style="margin: 15px;" class="waves-effect waves-light btn-large emptygreen" :href="'#/customers/'+this.$route.params.customer_id+'/places/'+this.$route.params.place_id+'/inspections/'+this.$route.params.inspection_id +'/edit'" v-if="inspection.editable">{{$t('menu.buttons.edit')}}</a>
                <modal v-if="inspection.removable" :question="$t('customer.contact_remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="inspectionRemoveQuestion" v-on:onConfirm="removeInspection(inspection)" />
            </div>
        </div>
         <div class="row" style="padding-top: 20px;"  v-if="inspection.company_logo && this.$route == null">
            <img :src="logo" style="max-width: 100%;"/>
        </div>
        <div v-if="loaded && inspection.v3">
            <div class="row">
                <div class="col-xs-6 col-xs-offset-3 column" style="padding-right: 1em;">
                    <center>
                        <h5 id="nazwa">{{$t('inspection_summary.title')}}</h5>
                        <h5>
                            NR <b>{{inspection.no}}</b>
                        </h5>
                    </center>
                </div>
            </div>
            <div class="row" v-if="inspection.company_name">
                <div class="col s4">
                    <p>
                        <b>{{$t('inspection_summary.contractor')}}:</b>
                        <br>{{inspection.company_name}}<br />
                        {{inspection.company_address.street}}<br />
                        {{inspection.company_address.postal_code}} {{inspection.company_address.city}}
                    </p>
                </div>
                <div class="col s4">
                    <p>
                        <b>{{$t('inspection_summary.client')}}:</b>
                        <br>{{inspection.customer_name}}<br />
                        {{inspection.customer_address.street}}<br />
                        {{inspection.customer_address.postal_code}} {{inspection.customer_address.city}}
                    </p>
                </div>
                <div class="col s4">
                    <p>
                        <b>{{$t('inspection_summary.where')}}:</b>
                        <br>{{inspection.place_name}}<br />
                        {{inspection.place_address.street}}<br />
                        {{inspection.place_address.postal_code}} {{inspection.place_address.city}}
                    </p>
                </div>
            </div>
            
            <p v-html="$t('inspection_summary.inspection_made', { day: $options.filters.formatDate(inspection.date) })"></p>
            <p>{{$t('inspection_summary.devices_title')}}</p>
            <template v-for="(items, zone) in groups">
                <p v-if="zone != 'null'">{{$t('inspection.zone')}}: <b>{{zone}}</b></p>
                <table>
                    <tr>
                        <th>{{$t('inspection.device_category')}}</th>
                        <th>{{$t('inspection_summary.substances')}}</th>
                        <th>{{$t('inspection_summary.amount_of_points')}}</th>
                        <th>{{$t('inspection_summary.controlled')}}</th>
                        <th>{{$t('inspection_summary.cleanup')}}</th>
                        <th>{{$t('inspection_summary.replaced')}}</th>
                    </tr>
                    <tr v-for="(item, i) in items" v-bind:style="(i == (items.length -1)) ? {'border-bottom': 'none'} : {}">
                        <td>{{item.dev_type_name}}</td>
                        <td><template v-for="(substance, index) in item.substances"><substancepopup :substance="substance"/><template v-if="index+1 < item.substances.length">,</template>&nbsp;</template> </td>
                        <td>{{item.out_of}}</td>
                        <td>{{item.total}}</td>
                        <td>{{item.cleanup}}</td>
                        <td>{{item.substance_replaced}}</td>
                    </tr>
                </table>
            </template>
            <b> {{$t('inspection_summary.inspection_showed')}}:</b>
            <ol class="devices_sum" v-if="loaded">
                <li v-if="inspection.low_activity_devs.length > 0">
                    {{$t('inspection_summary.low_activity_title')}}:
                    <template v-for="(device_number, i) in inspection.low_activity_devs">
                        <devicepopup :item="{number: device_number[0], device_id: device_number[1], real_time: inspection.date}" :place_id="inspection.place_id" :customer_id="inspection.customer_id"/><template v-if="i+1 < inspection.low_activity_devs.length">,</template>&nbsp; 
                    </template>
                </li>
                <li v-if="inspection.medium_activity_devs.length > 0">
                     {{$t('inspection_summary.medium_activity_title')}}:
                     <template v-for="(device_number, i) in inspection.medium_activity_devs">
                        <devicepopup :item="{number: device_number[0], device_id: device_number[1], real_time: inspection.date}" :place_id="inspection.place_id" :customer_id="inspection.customer_id"/><template v-if="i+1 < inspection.medium_activity_devs.length">,</template>&nbsp;
                    </template>
                </li>
                <li v-if="inspection.high_activity_devs.length > 0">
                    {{$t('inspection_summary.high_activity_title')}}:
                    <template v-for="(device_number, i) in inspection.high_activity_devs">
                        <devicepopup :item="{number: device_number[0], device_id: device_number[1], real_time: inspection.date}" :place_id="inspection.place_id" :customer_id="inspection.customer_id"/><template v-if="i+1 < inspection.high_activity_devs.length">,</template>&nbsp;
                    </template>
                </li>
                <li v-if="inspection.very_high_activity_devs.length > 0">
                    {{$t('inspection_summary.very_high_activity_title')}}:
                    <template v-for="(device_number, i) in inspection.very_high_activity_devs">
                        <devicepopup :item="{number: device_number[0], device_id: device_number[1], real_time: inspection.date}" :place_id="inspection.place_id" :customer_id="inspection.customer_id"/><template v-if="i+1 < inspection.very_high_activity_devs.length">,</template>&nbsp; 
                    </template>
                </li>
            </ol>
            <p>
                <template v-if="inspection.no_observed_pests">{{$t('inspection_summary.no_devices_pests')}}</template>
                <template v-else>{{$t('inspection_summary.activities')}} {{inspection.observed_pests}}</template>
            </p>
            <p>
                <template>{{$t('inspection_summary.activities_outside')}}:
                    <template v-for="(pest, index) in inspection.inspection_pests">
                        {{pest.pest_name}} <template v-if="index+1 < inspection.inspection_pests.length">,&nbsp;</template>
                    </template>
                </template>
            </p>
            <p>
                {{$t('inspection_summary.technical_state')}}:
            </p>
             <p>{{$t('inspection_summary.comments_recommendations')}}:</p>
            <p>
                {{inspection.conditions_notions}}<br/>
                <template v-for="reco in unresolved_recommendations">
                    {{reco.about}} - {{reco.solution}}<br/>
                </template>
            </p>
            <p>{{$t('inspection_summary.devices_notions')}}</p>
            <p>
                <template v-for="problem in inspection.problems">
                    {{problem}}<br/>
                </template>
            </p>
            <p>{{$t('inspection_summary.customer_announcements')}}: {{inspection.users_declaration}}
            </p>
            <template v-if="loaded && inspection.dosages.length > 0">
                <p><b>{{$t('inspection_summary.substances_used')}}</b></p>
                <table>
                    <tr>
                        <th>{{$t('inspection.name')}}</th>
                        <th>{{$t('inspection.amount')}}</th>
                        <th>{{$t('inspection.usage')}}</th>
                        <th>{{$t('inspection.replaced_suplemented')}}</th>
                        <th v-if="new_dosage">{{$t('inspection.new_dosage')}}</th>
                    </tr>
                    <tr v-for="dose in inspection.dosage_table">
                        <td>{{dose.name}}</td>
                        <td>{{dose.applied}} {{dose.unit}}</td>
                        <td>{{dose.consumed==0.0 ? "-------" : dose.consumed}} {{dose.consumed==0.0 ? "" : dose.unit}}</td>
                        <td>{{dose.replaced}} {{dose.unit}}</td>
                        <td v-if="new_dosage">
                            <template v-if="dose.dose_change">{{dose.new_dose}} {{dose.unit}}</template>
                            <template v-else>-------</template>
                        </td>
                    </tr>
                </table>
            </template>
            <template v-if="loaded && inspection.has_seals">
                <p><b>{{$t('inspection_summary.seal_numbers')}}</b></p>
                <table>
                    <tr>
                        <th>{{$t('inspection_summary.devnumber')}}</th>
                        <th>{{$t('inspection_summary.sealnumber')}}</th>
                    </tr>
                    <tr v-for="seal in inspection.seals">
                        <td>{{seal.number}}</td>
                        <td>{{seal.seal_number}}</td>
                    </tr>
                </table>
            </template>
            <p>{{$t('inspection_summary.generation_date')}}: {{inspection.date | formatDate}}</p>
            <p>{{$t('inspection_summary.changed_at')}}: {{inspection.updated_at | formatDate}}</p>
            <p>{{$t('inspection_summary.inspected_by')}}: {{inspection.worker}}</p>
            <p>{{$t('inspection_summary.generated_protocol')}}</p>
            <p>{{$t('inspection_summary.signature_not_required')}}</p>
        </div>
         <div v-if="loaded && !(inspection.v3)"  style="height: calc(100vh - 200px);">
            <object :data="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '/summary.pdf'" type="application/pdf" width="100%" height="100%">
            </object>
        </div>
        <div v-if="!loaded">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            loaded: false,
            inspection: {
                company_address: {},
                place_address: {},
                exceeded_zones: [],
                dosage_table: [],
                answers: [],
            },
            pests: {},
            pestslist: [],
            act_levels: [this.$t('devices.no_activity_short'), this.$t('devices.low_activity_short'), this.$t('devices.average_activity_short'), this.$t('devices.high_activity_short'), this.$t('devices.very_high_activity_short')],
            long_act_levels: [this.$t('devices.no_activity'), this.$t('devices.low_activity'), this.$t('devices.average_activity'), this.$t('devices.high_activity'), this.$t('devices.very_high_activity')],
            problem_kinds: ["", this.$t('inspection.not_found'), this.$t('inspection.unreadable_code'), this.$t('inspection.unavailable'), this.$t('inspection.need_remove'), this.$t('inspection.destroyed'), this.$t('inspection.temporary_disabled')],
        }
    },
    props: {data: Object},
    created() {
        console.log(this.data)
        if(this.data){
            this.inspection = this.data;
            if (this.inspection.worker_signature.indexOf('data:image/png;base64,') == -1) {
                this.inspection.worker_signature = 'data:image/png;base64,' + this.inspection.worker_signature
            }
            if(this.$route == null){
                document.title = this.inspection.summary_title;
            }
            this.loaded = true;
        }else{
            this.load_inspection();
        }
    },
    methods: {
        async load_inspection() {
            var response = await axios.get('/pests.json');
            this.pests_dict = _.keyBy(response.data, 'id');
            this.pestslist = response.data;
            var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '.json');
            this.inspection = response.data;
            if(_.isNil(response.data.prebuilt_json) == false){
                var prebuilt = await axios.get(response.data.prebuilt_json);
                this.inspection = _.extend(this.inspection, prebuilt.data);
            }
            if (this.inspection.worker_signature.indexOf('data:image/png;base64,') == -1) {
                this.inspection.worker_signature = 'data:image/png;base64,' + this.inspection.worker_signature
            }
            for (var pc of this.inspection.properties_casting) {
                pc.items = _.uniqBy(pc.items, 'device_id');
            }
            this.loaded = true;
        },
        zones_groupped(kind) {
            var reachedout = [];
            var reacheds = this.inspection.exceeded_individual_zones;
            for (var i = reacheds.length - 1; i >= 0; i--) {
                var reached = reacheds[i];
                for (var j = reached.pests_quantities.length - 1; j >= 0; j--) {
                    var pt = reached.pests_quantities[j];
                    if (pt.crit_calculation_method == kind) {
                        reachedout.push([reached.zone_name, reached.device_category_name, pt.pest_name, reached.device_number, pt])
                    }
                }

            }
            return _.groupBy(reachedout, function(arr) { return [arr[0], arr[1], arr[2]] });
        },
        removeInspection(inspection) {
            var that = this;
            axios.delete("/customers/" + inspection.customer_id + "/places/" + inspection.place_id + "/inspections/" + inspection.id + ".json").then((response) => {
                that.$router.push({ name: 'inspections' })
            })
        }
    },
    computed: {
        logo(){
            return "data:image/svg+xml;base64,"+btoa(encodeURIComponent(this.inspection.company_logo).replace(/%([0-9A-F]{2})/g,
                function(_, p1){ return String.fromCharCode('0x' + p1) }
              )) ;
        },
        groups() {
            return _.groupBy(this.inspection.summary, 'zone_name')
        },
        property_groups() {
            return _.groupBy(this.inspection.properties_casting, 'zone_name')
        },
        unresolved_recommendations(){
            return _.filter(this.inspection.recommendations, {status: 'unresolved'});
        },
        new_dosage(){
            return !_.isEmpty(_.filter(this.inspection.dosage_table, function(dosage){
                            return dosage.dose_change
                        }));
        },
        zones_pest_anyofs_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("anyof")
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var sumCond = 0;
                    var pg = _.map(groups[kij], _.last);
                    for (var j = pg.length - 1; j >= 0; j--) {
                        sumCond += pg[j].quantity
                    }
                    var pestid = pg[0].pest_id;
                    var pt = _.find(pg[0].thresolds, { pest_id: pestid })
                    if (sumCond < pt.medium_activity_thresold) {
                        sumCond = 1
                    } else if (sumCond < pt.high_activity_thresold) {
                        sumCond = 2
                    } else if (sumCond < pt.very_activity_thresold) {
                        sumCond = 3
                    } else if (sumCond >= pt.medium_activity_thresold) {
                        sumCond = 4
                    }

                    var crit = _.first(pg).critical_point;
                    if (sumCond > crit) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_anyofs_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("anyof")
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var suma = _.sum(conds);
                    var sumCond = 0;
                    if (sumCond < pg[0].thresolds.medium_activity_thresold) {
                        sumCond = 1
                    } else if (sumCond < pg[0].thresolds.high_activity_thresold) {
                        sumCond = 2
                    } else if (sumCond < pg[0].thresolds.very_activity_thresold) {
                        sumCond = 3
                    } else if (sumCond >= pg[0].thresolds.medium_activity_thresold) {
                        sumCond = 4
                    }
                    var disaster = _.first(pg).disaster_point;
                    if (sumCond > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }

            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_avgs_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("avg");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var crit = _.first(pg).critical_point;
                    if (_.mean(conds) > crit) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_avgs_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("avg");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var disaster = _.first(pg).disaster_point;
                    if (_.mean(conds) > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_meds_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("median");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var crit = _.first(pg).critical_point;
                    if (median(conds) > crit) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_meds_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("median");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var disaster = _.first(pg).disaster_point;
                    if (median(conds) > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_maxes_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("max");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var crit = _.first(pg).critical_point;
                    for (var j = groups[kij].length - 1; j >= 0; j--) {
                        var grup = groups[kij][j]
                        if (grup[4].conditions > crit) {
                            reaches.push(grup);
                        }
                    }

                }
            }
            return Object.entries(_.groupBy(reaches, function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_maxes_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("max");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var disaster = _.first(pg).disaster_point;
                    if (_.max(conds) > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        }
    }

}
</script>
<style scoped>
.modal-trigger{
    margin: 15px!important;
}
.btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
    line-height: 36px;
}

tr:last-child {
    border-bottom: none;
}

.addresses,
.addresses th,
.addresses td,
.properties,
.properties th,
.properties td {
    border: 1px solid rgba(0, 0, 0, 1);
    padding-left: 5px;
}

.properties,
.properties th,
.properties td {
    font-size: 10px;
    padding: 5px 5px;
    text-align: center;
}

tr>.current {
    border-left: 2px solid black;
}

tr>.current~.current {
    border: 1px solid rgba(0, 0, 0, 1);
}

.bolded-top {
    border-top: 2px solid black !important;
}

.bolded-left {
    border-left: 2px solid black !important;
}

.bolded-right {
    border-right: 2px solid black !important;
}

.bolded-bottom {
    border-bottom: 2px solid black !important;
}

tr:last-child>.current {
    border-bottom: 2px solid black !important;
}

th {
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
    font-weight: initial;
    padding-left: 0px;
}

td {
    padding-left: 0px;
}



.btn {
    margin-bottom: 5px;
}

.col p {
    margin: .7666666667rem 0 0.46rem 0;
}

.exceedvalues .col {
    line-height: 2;
}
.btn-small {
    margin: 15px!important;
}
/deep/ .btn-small {
    margin: 15px !important;
    height: 36px !important;
    line-height: 36px !important;
}
.companylogo {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
}
/deep/ .companylogo svg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
/deep/ .avoid-break {
  break-inside: avoid;
  page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
}
</style>
